import { defineStore } from "pinia";
import { ApiGetLearnDashboard, ApiGetChildInfo } from "@/service/apis/parents";
export const useUserInfoStore = defineStore("userInfo", {
  state: () => {
    return {
      ins: "",
      reload: false,
      student: {
        stuID: "",
        studentName: "",
        uniinfo: "",
        exp: "",
        level: "",
        image: "",
        title: "",
        titleid: "",
        titlelv: 1,
        broadcastTickets: "0",
        amt_exp: "",
        titleObject: null,
        checkInRecord: "true",
        plcmt_lvl: "",
      },
      lockImage: [],
      allAvatar: [],
      hint: {
        totalAssignmentNum: 0,
        totalEchoValleyNum: 0,
        totalReward: 0,
      },
      parent: {
        token: "",
        email: "",
        parentID: "",
        parentName: "",
        child: [],
        selectChild: {
          username: "",
        },
        selectClass: "",
        selectClassId: "",
        childClassList: [],
        childLearnInfo: null,
      },
      institution: {},
      school: {},
    };
  },
  actions: {
    // parent page
    async getLearnDashboard(myclass = null) {
      console.log("get dashboard");
      console.log("myclass = ", myclass);
      if (myclass !== null) {
        this.parent.selectClassId = myclass.courseid;
        this.parent.selectClass = myclass.course_name;
      }
      console.log("parent.selectClassId = ", this.parent.selectClassId);
      let result = await ApiGetLearnDashboard.get(
        this.parent.email,
        this.getDefaultStdId,
        this.parent.selectClassId
      );
      this.parent.childLearnInfo = result;
      console.log("all Parent need information = ", result);
      const userInfo = useUserInfoStore();
      console.log("this.student.studentName = ", this.student.studentName);
      return true;
    },
    async getChildInfo() {
      console.log("重新得到所有學生資訊");
      let result = await ApiGetChildInfo.get(this.parent.email);
      console.log("getChildInfo and study state = ", result);
      if (result.status === "success") {
        if (this.student.studentName === "") {
          this.parent.selectChild = result.stuInfo[0];
          this.parent.child = result.stuInfo;
        } else {
          result.stuInfo.forEach((std) => {
            if (std.stuid === this.student.stuID) {
              this.parent.selectChild = std;
              this.parent.child = result.stuInfo;
            }
          });
        }
        let tempArray = [];
        console.log("now student  = ", this.getDefaultStdName);
        result.record.forEach((item) => {
          if (item.username === this.getDefaultStdName) {
            tempArray.push(item);
            console.log("setting select class");

            this.parent.selectClass = item.course_name;
            this.parent.selectClassId = item.courseid;
          }
        });

        this.parent.childClassList = tempArray;

        return true;
      }
    },
  },
  getters: {
    getLearnHis: (state) => (type) => {
      let temp = null;
      state.parent.childLearnInfo.history.record.forEach((item) => {
        if (item.courseid === state.parent.selectClassId) {
          item.learningstatus.record.forEach((le) => {
            if (type === le.type && le.sum !== 0) {
              // console.log(le);
              temp = le.sum;
            }
          });
        }
      });
      // console.log(temp);
      return temp;
    },
    getClassLearnHis: (state) => (cid, type) => {
      let temp = 0;
      state.parent.childLearnInfo.history.record.forEach((item) => {
        if (item.courseid === cid) {
          item.learningstatus.record.forEach((le) => {
            if (type === le.type && le.sum !== 0) {
              // console.log(le);
              temp = le.sum;
            }
          });
        }
      });
      // console.log(temp);
      return temp;
    },
    // my title
    getFullLockImage: (state) => {
      console.log(state.student.titleObject.isAdvance_title);
      if (state.student.titleObject.isAdvance_title) {
        return state.lockImage[1];
      } else {
        console.log(123);
        return state.lockImage[0];
      }
    },
    //
    getagtCompleteRate: (state) => {
      let tempTotal = 0;
      let tempComplete = 0;
      if (state.parent.childLearnInfo !== null) {
        state.parent.childLearnInfo.assignmentCompleteRate.record.forEach(
          (item) => {
            tempTotal = tempTotal + item.total;
            tempComplete = tempComplete + item.complete;
          }
        );
        return (tempComplete / tempTotal).toFixed(2) * 100;
      } else {
        return null;
      }
    },

    getAgtRewardList: (state) => {
      // 這裡的資訊在本地這裡 USERINFO 取得的
      let stdAwardList = JSON.parse(
        JSON.stringify(state.parent.childLearnInfo)
      );
      console.log(stdAwardList);
      let temp = [];
      temp = stdAwardList.rewardList.record.filter((task) => {
        return task.tasktype === "assignment";
      });
      console.log(temp);
      return temp;
    },

    getDefaultStdId: (state) => {
      console.log(state.parent.selectChild);
      if (state.parent.selectChild.username) {
        return state.parent.selectChild.stuid;
      } else {
        return state.parent.selectChild.stuID;
      }
    },
    getDefaultStdName: (state) => {
      console.log(state.parent.selectChild);
      if (state.parent.selectChild !== null) {
        if (state.parent.selectChild.username) {
          return state.parent.selectChild.username;
        } else {
          return state.parent.selectChild.studentName;
        }
      } else {
        return "none";
      }
    },
    getTempTitle: (state) => {
      console.log(state.student.titleObject);
      return state.student.titleObject;
    },
    getTitleImageColor: (state) => {
      if (state.student.titleObject.isAdvance_title) {
        // 若等級不到2 則顯示灰色
        if (state.student.titleObject.titleAvaliable === false)
          return "grey_filter";
        // 正常顯示顏色
        else return "";
      } else {
        // 正常顯示顏色
        return "";
      }
    },
    getClassExpiryDate: (state) => {
      if (state.parent.childLearnInfo.history.record.length !== 0) {
        let temp = state.parent.childLearnInfo.history.record.filter((item) => {
          return item.courseid === state.parent.selectClassId;
        });
        console.log(temp);
        if (temp.length === 0) {
          return [];
        } else {
          return temp[0].expiry_date;
        }
      }
    },
  },
  persist: true,
});
